import { FC } from 'react'
import { generateIdForItem } from '../../../../lib/IdGenerator'
import { Spend } from '../../../../lib/Types'
import ReconciliationSpendRow from './ReconciliationSpendRow'

interface Props {
  spend: Spend
}
const ReconciliationSpend: FC<Props> = ({ spend }) => {
  return (
    <>
      <tr className='bg-gray-100 border-x border-gray-300 draggable'>
        <td className='draggable-wrapper'>
          <ReconciliationSpendRow
            spend={spend}
            showChildren={true}
          />
          {spend.children.length > 0 && (
            <table
              className={'min-w-full table-budget col-3'}
            >
              <tbody>
                {spend.children.map((child) => (
                  <tr
                    key={generateIdForItem(child)}
                    className='bg-gray-100 border-b border-gray-300 draggable-spend'
                  >
                    <td className='draggable-wrapper'>
                      <ReconciliationSpendRow spend={child} isChild />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </td>
      </tr>
    </>
  )
}

export default ReconciliationSpend
